import React from "react";
import Header from "../partials/Header";
import HeroHome from "../partials/HeroHome";
import OurApproach from "../partials/OurApproach";
import ContactUs from "../partials/ContactUs";
import Testimonials from "../partials/Testimonials";
import FindUs from "../partials/FindUs";
import Footer from "../partials/Footer";

function Home() {
	return (
		<div className="flex flex-col min-h-screen overflow-hidden">
			{/*  Site header */}
			<Header />
			{/*  Page content */}
			<main className="flex-grow">
				{/*  Page sections */}
				<HeroHome />
				<FindUs />
				<Testimonials />
				<OurApproach />
				<ContactUs />
			</main>

			{/*  Site footer */}
			<Footer />
		</div>
	);
}

export default Home;
